
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as accountzDnv8yprHgPaoQYqNVtQxovMUFuBCZtieouMgM7jMVUMeta } from "/opt/build/repo/pages/play/shopify/account.vue?macro=true";
import { default as _91token_938MvQeFQkqreV4XhNmHAGr_45A54OQSGF4k2WgAbRdzObIMeta } from "/opt/build/repo/pages/play/redirect/[token].vue?macro=true";
import { default as referralDze_45F6xBR8LwUr7I_kVBH_fBYPRgfzCYHnYA2j3lxo8Meta } from "/opt/build/repo/pages/play/shopify/referral.vue?macro=true";
import { default as indexXp_45f6Gn__7yxXT0zS70jg13CI6Y_45Z_Bte_SDEub1kKgMeta } from "/opt/build/repo/pages/play/tiktok-oauth/index.vue?macro=true";
import { default as indexBGJO6_45y9w8iUcJIIoQdVs9GNxkRohDsiyuKCOZuPhC4Meta } from "/opt/build/repo/pages/play/[company]/[companyId]/sms/index.vue?macro=true";
import { default as indexjfySRfrHYjwJurFheQFUrCgNoX_45i7FOD83ShbeoAOwwMeta } from "/opt/build/repo/pages/play/[company]/[companyId]/[program]/index.vue?macro=true";
import { default as index1uBgo2ewqH1oIw31tcpmdy98Ar3w_yLTdWS__45mejGmkMeta } from "/opt/build/repo/pages/play/[company]/[companyId]/unsubscribe/index.vue?macro=true";
import { default as indexgqLKG7TxX_45M0k_451JfeK_45584dt_45p7FfRn3NeL9BiC02QMeta } from "/opt/build/repo/pages/play/[company]/[companyId]/[program]/in-app/index.vue?macro=true";
import { default as embeddedepZ8B8Wzg98d0ulAbAZ5B77AbEgnRpo_45xVP3lfgJ85UMeta } from "/opt/build/repo/pages/play/[company]/[companyId]/[program]/shopify/embedded.vue?macro=true";
import { default as _91rewardId_93MDTLoiZzJdSppPdRl7uCBYG_tX6lPnGPGiULBSeR85oMeta } from "/opt/build/repo/pages/play/[company]/[companyId]/[program]/reward/[rewardId].vue?macro=true";
import { default as index8ydlQsMFnB6jX2XQY6xDEvE75zOIH_ewdzvh1gJCZkgMeta } from "/opt/build/repo/pages/play/[company]/[companyId]/[program]/new-password/index.vue?macro=true";
import { default as _91challengeId_93XcwvF4ZHTXbd25d0sPmiBsGUvXaTQeI82JHmUPeTSlUMeta } from "/opt/build/repo/pages/play/[company]/[companyId]/[program]/challenge/[challengeId].vue?macro=true";
import { default as _91companyId_93rRHffVVj7Vi3xmK2k6hZY1OVQ90Zzz_45MCyh_EXJf4QYMeta } from "/opt/build/repo/pages/play/[company]/[companyId].vue?macro=true";
import { default as section_45referralbc6C8SNZIp_nmYXM682MbGyaSyugLy_45EkP9lXU63V7MMeta } from "/opt/build/repo/pages/play/shopify/section-referral.vue?macro=true";
export default [
  {
    name: "play-shopify-account",
    path: "/play/shopify/account",
    meta: accountzDnv8yprHgPaoQYqNVtQxovMUFuBCZtieouMgM7jMVUMeta || {},
    component: () => import("/opt/build/repo/pages/play/shopify/account.vue")
  },
  {
    name: "play-redirect-token",
    path: "/play/redirect/:token()",
    meta: _91token_938MvQeFQkqreV4XhNmHAGr_45A54OQSGF4k2WgAbRdzObIMeta || {},
    component: () => import("/opt/build/repo/pages/play/redirect/[token].vue")
  },
  {
    name: "play-shopify-referral",
    path: "/play/shopify/referral",
    meta: referralDze_45F6xBR8LwUr7I_kVBH_fBYPRgfzCYHnYA2j3lxo8Meta || {},
    component: () => import("/opt/build/repo/pages/play/shopify/referral.vue")
  },
  {
    name: "play-tiktok-oauth",
    path: "/play/tiktok-oauth",
    meta: indexXp_45f6Gn__7yxXT0zS70jg13CI6Y_45Z_Bte_SDEub1kKgMeta || {},
    component: () => import("/opt/build/repo/pages/play/tiktok-oauth/index.vue")
  },
  {
    name: "play-company-companyId",
    path: "/play/:company()/:companyId()",
    meta: _91companyId_93rRHffVVj7Vi3xmK2k6hZY1OVQ90Zzz_45MCyh_EXJf4QYMeta || {},
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId].vue"),
    children: [
  {
    name: "play-company-companyId-sms",
    path: "sms",
    meta: indexBGJO6_45y9w8iUcJIIoQdVs9GNxkRohDsiyuKCOZuPhC4Meta || {},
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId]/sms/index.vue")
  },
  {
    name: "play-company-companyId-program",
    path: ":program()",
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId]/[program]/index.vue")
  },
  {
    name: "play-company-companyId-unsubscribe",
    path: "unsubscribe",
    meta: index1uBgo2ewqH1oIw31tcpmdy98Ar3w_yLTdWS__45mejGmkMeta || {},
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId]/unsubscribe/index.vue")
  },
  {
    name: "play-company-companyId-program-in-app",
    path: ":program()/in-app",
    meta: indexgqLKG7TxX_45M0k_451JfeK_45584dt_45p7FfRn3NeL9BiC02QMeta || {},
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId]/[program]/in-app/index.vue")
  },
  {
    name: "play-company-companyId-program-shopify-embedded",
    path: ":program()/shopify/embedded",
    meta: embeddedepZ8B8Wzg98d0ulAbAZ5B77AbEgnRpo_45xVP3lfgJ85UMeta || {},
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId]/[program]/shopify/embedded.vue")
  },
  {
    name: "play-company-companyId-program-reward-rewardId",
    path: ":program()/reward/:rewardId()",
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId]/[program]/reward/[rewardId].vue")
  },
  {
    name: "play-company-companyId-program-new-password",
    path: ":program()/new-password",
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId]/[program]/new-password/index.vue")
  },
  {
    name: "play-company-companyId-program-challenge-challengeId",
    path: ":program()/challenge/:challengeId()",
    component: () => import("/opt/build/repo/pages/play/[company]/[companyId]/[program]/challenge/[challengeId].vue")
  }
]
  },
  {
    name: "play-shopify-section-referral",
    path: "/play/shopify/section-referral",
    meta: section_45referralbc6C8SNZIp_nmYXM682MbGyaSyugLy_45EkP9lXU63V7MMeta || {},
    component: () => import("/opt/build/repo/pages/play/shopify/section-referral.vue")
  }
]